function CheckPureconnectAvailable() {
  try {
    if (typeof widgetAvailable === 'function' && widgetAvailable() === true) {
      var ele = document.getElementById('agent-chat')
      var classString = ele.className + ' ready'
      ele.className = classString
      clearInterval(pureconnectInterval)
    }
  } catch (err) {
    console.log(err)
  }
}

var pureconnectInterval = setInterval(function () {
  CheckPureconnectAvailable()
}, 1000)
setTimeout(function () {
  clearInterval(pureconnectInterval)
}, 15000)

document.addEventListener('click', function (e) {
  if (e.target.id == 'agent-chat') {
    if (e.target.className.contains('ready')) {
    } else {
      return false
    }
  }
})

document.addEventListener("DOMContentLoaded", () => {
  const chatLink = document.getElementsByClassName("util-link-chatbot")[0];

  if (!chatLink) return;

  chatLink.addEventListener("click", (event) => {
      event.preventDefault();
      openPoshChat();
  });

  setTimeout(() => {
    chatLink.classList.add("showing");
  }, 2000);

  function openPoshChat() {
    if (typeof posh !== 'undefined')
      posh.open();

    else {
      // Posh not loaded yet, wait and try again
      setTimeout(() => {
        openPoshChat();
      }, 200);
    }
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const chatLink = document.querySelector(".util-link-chatbot");

  if (!chatLink) return;


  const DELTA_PX    = 20;
  const COOLDOWN_MS = 300;
  let lastScrollY   = window.pageYOffset;
  let lastToggleTS  = Date.now();

  chatLink.addEventListener("click", (e) => {
    e.preventDefault();
    openPoshChat();
  });

  window.addEventListener("scroll", () => {
    const currentY = window.pageYOffset;
    const delta   = currentY - lastScrollY;
    const now     = Date.now();

    if (Math.abs(delta) > DELTA_PX && now - lastToggleTS > COOLDOWN_MS) {
      if (delta > 0)
        chatLink.classList.remove("showing");
      else 
        chatLink.classList.add("showing");

      lastToggleTS = now;
    }

    lastScrollY = currentY;
  });

  function openPoshChat() {
    if (typeof posh !== "undefined") {
      posh.open();
    } else {
      setTimeout(openPoshChat, 200);
    }
  }
});
